import * as React from "react";
import { useTranslation } from "react-i18next";
import Icon from "components/common/Icon";
const StatusIcon = ({ active, className = void 0 }, ref) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(
    Icon,
    {
      ref,
      name: active ? "check_circle" : "cancel",
      bsStyle: active ? "success" : void 0,
      className,
      title: active ? t("status_icon.yes") : t("status_icon.no")
    }
  );
};
export default React.forwardRef(StatusIcon);
